import React, { createContext, forwardRef } from 'react'
import PropTypes from 'prop-types'
import { FooterSection } from './footer-section'
import { FooterRow } from './footer-row'
import { FooterColumn } from './footer-column'
import { FooterNav } from './footer-nav'
import { FooterNavItem } from './footer-nav-item'

const FooterContext = createContext()

const Footer = forwardRef((props, ref) => {
  const { children } = props
  return (
    <FooterContext.Provider>
      <div className="dev_dash__footer_container">
        <footer ref={ref} className="dev_dash__footer">
          {children}
        </footer>
      </div>
    </FooterContext.Provider>
  )
})

Footer.Section = FooterSection
Footer.Row = FooterRow
Footer.Column = FooterColumn
Footer.Nav = FooterNav
Footer.NavItem = FooterNavItem

export { Footer }

Footer.displayName = 'Footer'

Footer.propTypes = {
  children: PropTypes.any.isRequired,
}
